import { render, staticRenderFns } from "./loadingIcon.vue?vue&type=template&id=48337e32&scoped=true&"
import script from "./loadingIcon.vue?vue&type=script&lang=js&"
export * from "./loadingIcon.vue?vue&type=script&lang=js&"
import style0 from "./loadingIcon.vue?vue&type=style&index=0&id=48337e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48337e32",
  null
  
)

/* custom blocks */
import block0 from "./loadingIcon.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports